import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Contact, CONTACTS, ContactsState } from './types';

const initialState: ContactsState = {
  loading: false,
  contacts: [],
};

export const contactsSlice = createSlice({
  name: CONTACTS,
  initialState,
  reducers: {
    setContacts: (state, { payload }: PayloadAction<Contact[]>) => {
      state.contacts = payload;
    },
    setContactsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
  },
});

export const { setContacts, setContactsLoading } = contactsSlice.actions;
export default contactsSlice.reducer;
